export default "__VITE_ASSET__C836GlOl__"